export const queryKeys = {
  currentUserProfile: ['current-user-profile'] as const,
  adminRole: ['current-user-profile'] as const,
  staffProfilesBase: ['profiles', 'staff'] as const,
  staffProfiles: (params: {
    searchTerm: string
    roleFilter: string
    statusFilter: string
    sortKey: string
    sortDirection: string
    page: number
    pageSize: number
  }) =>
    [
      'profiles',
      'staff',
      params.searchTerm,
      params.roleFilter,
      params.statusFilter,
      params.sortKey,
      params.sortDirection,
      params.page,
      params.pageSize,
    ] as const,
  customerProfilesBase: ['profiles', 'customers'] as const,
  customerProfiles: (params: {
    searchTerm: string
    roleFilter: string
    statusFilter: string
    sortKey: string
    sortDirection: string
    page: number
    pageSize: number
  }) =>
    [
      'profiles',
      'customers',
      params.searchTerm,
      params.roleFilter,
      params.statusFilter,
      params.sortKey,
      params.sortDirection,
      params.page,
      params.pageSize,
    ] as const,
  trainerProfiles: ['profiles', 'trainers'] as const,
  profiles: ['profiles'] as const,
  courses: ['courses'] as const,
  publicCourses: ['courses', 'public'] as const,
  publicCourseCatalog: ['courses', 'public-catalog'] as const,
  sessionsBase: ['sessions'] as const,
  sessions: (from: string, to: string) => ['sessions', from, to] as const,
  sessionBookingCountsBase: ['session-booking-counts'] as const,
  sessionBookingCounts: (sessionIds: string[]) => ['session-booking-counts', sessionIds] as const,
  bookingsBase: ['bookings'] as const,
  bookings: (params: {
    statusFilter: string
    courseIdFilter: string | 'all'
    searchTerm: string
    sortKey: string
    sortDirection: string
    page: number
    pageSize: number
  }) =>
    [
      'bookings',
      params.statusFilter,
      params.courseIdFilter,
      params.searchTerm,
      params.sortKey,
      params.sortDirection,
      params.page,
      params.pageSize,
    ] as const,
  publicSessionsBase: ['public-sessions'] as const,
  publicSessions: (from: string, to: string) => ['public-sessions', from, to] as const,
  publicSession: (sessionId: string) => ['public-session', sessionId] as const,
  trainerSessionsBase: ['trainer-sessions'] as const,
  trainerSessions: (trainerId: string, from: string, to: string) =>
    ['trainer-sessions', trainerId, from, to] as const,
  sessionRegistrationSettings: ['session-registration-settings'] as const,
  sessionCancellationSettings: ['session-cancellation-settings'] as const,
  trainerDetails: (id: string) => ['trainer', id] as const,
  trainerCourses: (id: string) => ['trainer-courses', id] as const,
  sessionBookings: (sessionId: string) => ['session-bookings', sessionId] as const,
  subscriptionPackages: ['subscription-packages'] as const,
  userSubscription: ['user-subscription'] as const,
  userPurchasedPackages: ['user-purchased-packages'] as const,
  userPaymentEntries: ['user-payment-entries'] as const,
  voucherRedemption: ['voucher-redemption'] as const,
  memberBookings: ['member-bookings'] as const,
  memberBookingsUpcoming: ['member-bookings', 'upcoming'] as const,
  managedUserProfile: (userId: string) => ['managed-user', 'profile', userId] as const,
  managedUserBookings: (userId: string) => ['managed-user', 'bookings', userId] as const,
  managedUserPackages: (userId: string) => ['managed-user', 'packages', userId] as const,
  managedUserSubscription: (userId: string) => ['managed-user', 'subscription', userId] as const,
  managedUserPaymentEntries: (userId: string) =>
    ['managed-user', 'payment-entries', userId] as const,
  managedUserCreditAdjustments: (userId: string) =>
    ['managed-user', 'credit-adjustments', userId] as const,
  resourceCategories: ['resource-categories'] as const,
  resources: ['resources'] as const,
  vouchers: ['admin', 'vouchers'] as const,
  voucherGeneratedCode: ['admin', 'vouchers', 'generated-code'] as const,
  voucherUpdate: (id: string) => ['admin', 'vouchers', id, 'update'] as const,
  discounts: ['admin', 'discounts'] as const,
  discountMemberAssignments: (discountId: string) =>
    ['admin', 'discounts', discountId, 'members'] as const,
  memberDiscountAssignments: (userId: string) =>
    ['managed-user', 'discount-assignments', userId] as const,
  voucherReports: (params: { from: string; to: string; page: number; pageSize: number }) =>
    ['admin', 'reports', 'voucher-redemptions', params.from, params.to, params.page, params.pageSize] as const,
  admin: ['admin'] as const,
}
